import createErrorMessage from "@shared/factories/src/errorMessage.factory"
import * as clientApi from "@hub/order/src/api/client.api"
import { BAD_REQUEST_CODE, NOT_FOUND_ERROR_CODE, UNPROCESSABLE_CONTENT } from "@hub/order/src/constants"

export const fetchClient = async params => {
  try {
    const { data } = await clientApi.fetchClient(params)
    return data
  } catch (error) {
    console.error(error)

    if (error?.response?.status !== NOT_FOUND_ERROR_CODE) {
      window.$vue.$toast({
        type: "error",
        title:
          createErrorMessage(error).getMessage() ||
          "Falha ao obter dados do cliente."
      })
    }

    throw error
  }
}

export const fetchBepeople = async document => {
  try {
    const { data } = await clientApi.fetchBepeople(document)
    return data
  } catch (error) {
    console.error(error)

    if (error?.response?.status !== BAD_REQUEST_CODE && error?.response?.status !== NOT_FOUND_ERROR_CODE) {
      window.$vue.$toast({
        type: "error",
        title:
          createErrorMessage(error).getMessage() ||
          "Falha ao obter dados do cliente."
      })
    }

    throw error
  }
}

export const saveClient = async body => {
  try {
    const { data } = await clientApi.saveClient(body)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao salvar dados do cliente."
    })
    throw error
  }
}

export const updateClient = async (uuid, body) => {
  try {
    const { data } = await clientApi.updateClient(uuid, body)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao atualizar dados do cliente."
    })
    throw error
  }
}

export const verifyClient = async uuid => {
  try {
    const { data } = await clientApi.verifyClient(uuid)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Verificação reprovada!"
    })
    throw error
  }
}

export const fetchProfessions = async params => {
  try {
    const { data } = await clientApi.fetchProfessions(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao obter lista de profissões dados do cliente."
    })
    throw error
  }
}

export const fetchCompanyTypes = async params => {
  try {
    const { data } = await clientApi.fetchCompanyTypes(params)
    return data
  } catch (error) {
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao obter lista de tipos de empresas."
    })

    throw error
  }
}

export const checkEmail = async params => {
  try {
    const { data } = await clientApi.checkEmail(params)
    return data.status
  } catch (error) {
    console.error(error)
    return true
  }
}

export const fetchContactType = async params => {
  try {
    const { data } = await clientApi.fetchContactType(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao obter lista de tipos do contato."
    })
    throw error
  }
}

export const verifyLegalResponsibleDocument = async (params, document) => {
  try {
    const { data } = await clientApi.verifyLegalResponsibleDocument(params, document)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao verificar cpf do representante legal selecionado."
    })
    return false
  }
}

export const verifyDuplicatedClientContact = async payload => {
  try {
    const { data } = await clientApi.verifyDuplicatedClientContact(payload)
    return data
  } catch (error) {
    if(!error?.data?.alert_message && !error?.response?.data?.data?.alert_message) {
      window.$vue.$toast({
        type: "error",
        title:
          createErrorMessage(error).getMessage() ||
          "Falha ao verificar contatos do cliente."
      })
    }

    if(error?.response?.data) {
      throw error.response.data
    }

    throw error
  }
}

export const listCustomerOrigin = async () => {
  try {
    const { data } = await clientApi.listCustomerOrigin()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao obter lista de origens do cliente."
    })
    throw error
  }
}
